
import { Container, Typography } from '@material-ui/core';

const Presentation = () => {

    return (
        <Container>
            <Typography variant="h1" align="center" > ₿ase Characters</Typography>
            <Typography variant="h2" align="center" > ₿ase Characters is randomized Character generator and stored on chain. </Typography>
            <Typography variant="h2" align="center" > Functionality are intentionally omitted for others to interpret.</Typography>
            <Typography variant="h2" align="center" > Feel free to use ₿ase Characters in any way you want. </Typography>
        </Container>
    );
}


export default Presentation;